import './CustomFilterDeleteModal.scss';

import { Button, Modal } from 'antd';
import React from 'react';

import bem from '../../../../utils/bem';

export interface CustomFilterDeleteModalProps {
  visible: boolean;
  filterName?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const [block, element] = bem('custom-filter-delete-modal');

const DELETE_FILTER_MODAL_TITLE = 'Delete filter?';

const getDeleteFilterModalMessage = (filterName: string): string =>
  `Are you sure you want to delete "${filterName}"? This can't be undone.`;

const stopPropagation = (e: React.SyntheticEvent): void => e.stopPropagation();
const modalWrapProps = { onMouseDown: stopPropagation, onTouchStart: stopPropagation };

const CustomFilterDeleteModal = ({
  visible,
  filterName,
  loading = false,
  onConfirm,
  onCancel,
}: CustomFilterDeleteModalProps): JSX.Element | null => {
  if (!visible || !filterName) return null;

  const footerContent = [
    <Button key="cancel-button" className={element('cancel-button')} onClick={onCancel} disabled={loading}>
      Cancel
    </Button>,
    <Button
      key="confirm-button"
      type="primary"
      danger
      className={element('confirm-button')}
      onClick={onConfirm}
      loading={loading}
    >
      Delete
    </Button>,
  ];

  return (
    <Modal
      className={block()}
      open
      title={DELETE_FILTER_MODAL_TITLE}
      width={420}
      centered
      closable={false}
      maskClosable={!loading}
      keyboard={!loading}
      onCancel={onCancel}
      footer={footerContent}
      wrapProps={modalWrapProps}
    >
      <p className={element('message')}>{getDeleteFilterModalMessage(filterName)}</p>
    </Modal>
  );
};

export default CustomFilterDeleteModal;
